import React from 'react';
import SkeletonFadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut/SkeletonFadeInAndOut';
import type { FlightsInfoBanners } from '@lt/api/dist/methods/packages/types';
import CheckoutBannersList from './CheckoutBannersList/CheckoutBannersList';
import styles from './CheckoutBannersLoader.module.css';

type Props = {
  items: FlightsInfoBanners[];
  isMobile: boolean;
};

export const CheckoutBannersLoader = ({
  items,
  isMobile,
}: Props): JSX.Element => (
  <div className={styles.bannersContainer}>
    {items.length ? (
      <CheckoutBannersList items={items} isMobile={isMobile} />
    ) : (
      <SkeletonFadeInAndOut width="100%" height="66px" />
    )}
  </div>
);
